var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "content" } }, [
    _c("div", { staticClass: "header col-md-12" }, [
      _c("div", { staticClass: "header-inner row align-items-center" }, [
        _c("div", { staticClass: "col left" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("sidebar.saleorder")) +
                " > " +
                _vm._s(_vm.$t("sidebar.all")) +
                "\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col right" }, [
          _c("div", { staticClass: "action" }, [
            _c("div", { staticClass: "dropdown item" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn no-bg text-secondary dropdown-toggle filter",
                  attrs: {
                    type: "button",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }
                },
                [
                  _c("i", { staticClass: "fas fa-filter" }),
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("message.filter")) +
                      "\n              "
                  ),
                  [
                    _vm.query.status == "all"
                      ? _c("span", { staticClass: "badge badge-secondary" }, [
                          _vm._v(_vm._s(_vm.$t("message.all")))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.query.status == "padding"
                      ? _c("span", { staticClass: "badge badge-warning" }, [
                          _vm._v(_vm._s(_vm.$t("status.so.padding")))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.query.status == "rejected"
                      ? _c("span", { staticClass: "badge badge-danger" }, [
                          _vm._v(_vm._s(_vm.$t("status.so.rejected")))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.query.status == "uncompleted"
                      ? _c("span", { staticClass: "badge badge-info" }, [
                          _vm._v(_vm._s(_vm.$t("status.so.uncompleted")))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.query.status == "completed"
                      ? _c("span", { staticClass: "badge badge-success" }, [
                          _vm._v(_vm._s(_vm.$t("status.so.completed")))
                        ])
                      : _vm._e()
                  ]
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-menu dropdown-menu-right" }, [
                _c(
                  "form",
                  {
                    staticClass: "px-3 py-2",
                    staticStyle: { "min-width": "300px" }
                  },
                  [
                    _c("div", { staticClass: "form-group mb-0" }, [
                      _c("label", [_vm._v(_vm._s(_vm.$t("message.status")))]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.query.status,
                              expression: "query.status"
                            }
                          ],
                          staticClass: "form-control form-control-sm",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.query,
                                "status",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "all" } }, [
                            _vm._v(_vm._s(_vm.$t("message.all")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "option",
                            {
                              staticClass: "text-warning",
                              attrs: { value: "padding" }
                            },
                            [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.$t("status.so.padding")) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "option",
                            {
                              staticClass: "text-danger",
                              attrs: { value: "rejected" }
                            },
                            [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.$t("status.so.rejected")) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "option",
                            {
                              staticClass: "text-info",
                              attrs: { value: "uncompleted" }
                            },
                            [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.$t("status.so.uncompleted")) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "option",
                            {
                              staticClass: "text-success",
                              attrs: { value: "completed" }
                            },
                            [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.$t("status.so.completed")) +
                                  "\n                    "
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content col-md-12" },
      [
        !_vm.ready
          ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
          : _c("base-table", {
              attrs: { pagination: _vm.$store.state.app.pagination },
              on: { onPageChange: _vm.handlePageChange },
              scopedSlots: _vm._u([
                {
                  key: "thead",
                  fn: function() {
                    return [
                      _c("thead", [
                        _c("tr", [
                          _c("th", { staticStyle: { "min-width": "100px" } }, [
                            _vm._v(_vm._s(_vm.$t("documents.so")))
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "no-sort" }, [
                            _vm._v(_vm._s(_vm.$t("message.customer")))
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "no-sort" }, [
                            _vm._v(_vm._s(_vm.$t("message.productlist")))
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "no-sort" }, [
                            _vm._v(_vm._s(_vm.$t("documents.gi")))
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "no-sort" }, [
                            _vm._v(_vm._s(_vm.$t("documents.in")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("message.debttotal")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("message.paidtotal")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("message.grandtotal")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("message.scheduled_at")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "no-sort",
                              staticStyle: { "max-width": "100px" }
                            },
                            [_vm._v(_vm._s(_vm.$t("message.status")))]
                          )
                        ])
                      ])
                    ]
                  },
                  proxy: true
                },
                {
                  key: "tbody",
                  fn: function() {
                    return [
                      _c(
                        "tbody",
                        [
                          _c("tr", [
                            _vm.sales.length === 0
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "text-center",
                                    attrs: { colspan: "10" }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("message.notfounddata")) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.sales, function(item, index) {
                            return _c("tr", [
                              _c(
                                "td",
                                { attrs: { "data-order": item.so_id } },
                                [
                                  _c("router-link-custom", {
                                    attrs: {
                                      to: {
                                        name: "SaleOrderEdit",
                                        query: {
                                          so_id: item.so_id,
                                          so_code: item.so_code
                                        }
                                      },
                                      text: item.so_code,
                                      to_appid: 5,
                                      current_appid: 5
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  item.customer
                                    ? _c("router-link-custom", {
                                        attrs: {
                                          to: {
                                            name: "ContactCustomerEdit",
                                            query: {
                                              cus_id: item.customer.customer_id,
                                              cus_name:
                                                item.customer.customer_name
                                            }
                                          },
                                          text: item.customer.customer_name,
                                          to_appid: 11,
                                          current_appid: 5,
                                          disabled:
                                            item.customer.is_deleted == true
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c("item-list", {
                                    attrs: { orders: item.orders }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "vertical-align": "top" } },
                                _vm._l(item.reference.goodsissues, function(
                                  goodsissue,
                                  index_
                                ) {
                                  return _c(
                                    "div",
                                    [
                                      _c("router-link-custom", {
                                        attrs: {
                                          to: {
                                            name: "GoodsIssueEdit",
                                            query: {
                                              gi_id: goodsissue.gi_id,
                                              gi_code: goodsissue.gi_code
                                            }
                                          },
                                          text: goodsissue.gi_code,
                                          status: {
                                            text: _vm.getGoodsIssueStatus(
                                              goodsissue,
                                              _vm.$t
                                            ).message,
                                            color: _vm.getColorFormStatus(
                                              _vm.getGoodsIssueStatus(
                                                goodsissue,
                                                _vm.$t
                                              ).status
                                            ),
                                            type: "icon"
                                          },
                                          to_appid: 3,
                                          current_appid: 5
                                        }
                                      })
                                    ],
                                    1
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "vertical-align": "top" } },
                                _vm._l(item.reference.invoices, function(
                                  invoice,
                                  index_
                                ) {
                                  return _c(
                                    "div",
                                    [
                                      _c("router-link-custom", {
                                        attrs: {
                                          to: {
                                            name: "AccountsInvoiceEdit",
                                            query: {
                                              in_id: invoice.in_id,
                                              in_code: invoice.in_code
                                            }
                                          },
                                          text: invoice.in_code,
                                          status: {
                                            text: _vm.getInvoiceStatus(
                                              invoice,
                                              _vm.$t,
                                              _vm.mixin
                                            ).message,
                                            color: _vm.getColorFormStatus(
                                              _vm.getInvoiceStatus(
                                                invoice,
                                                _vm.$t,
                                                _vm.mixin
                                              ).status
                                            ),
                                            type: "icon"
                                          },
                                          to_appid: 12,
                                          current_appid: 5
                                        }
                                      })
                                    ],
                                    1
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  attrs: {
                                    "data-order": _vm.getDebtSaleAmount(item)
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getNumber(
                                          _vm.getDebtSaleAmount(item)
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  attrs: {
                                    "data-order": _vm._getPaymentTotal(
                                      item.reference.invoices
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getNumber(
                                          _vm._getPaymentTotal(
                                            item.reference.invoices
                                          )
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  attrs: {
                                    "data-order": _vm.getTotal(item.orders)
                                      .payment
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getNumber(
                                          _vm.getTotal(item.orders).payment
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { attrs: { "data-order": item.scheduled_at } },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.getDate(item.scheduled_at)) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "max-width": "100px" } },
                                [
                                  [
                                    _vm.getSaleStatus(item, _vm.$t, _vm.mixin)
                                      .status == "padding"
                                      ? _c(
                                          "span",
                                          { staticClass: "text-warning" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.getSaleStatus(
                                                    item,
                                                    _vm.$t,
                                                    _vm.mixin
                                                  ).message
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm.getSaleStatus(
                                          item,
                                          _vm.$t,
                                          _vm.mixin
                                        ).status == "completed"
                                      ? _c(
                                          "span",
                                          { staticClass: "text-success" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.getSaleStatus(
                                                    item,
                                                    _vm.$t,
                                                    _vm.mixin
                                                  ).message
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm.getSaleStatus(
                                          item,
                                          _vm.$t,
                                          _vm.mixin
                                        ).status == "uncompleted"
                                      ? _c(
                                          "span",
                                          { staticClass: "text-info" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.getSaleStatus(
                                                    item,
                                                    _vm.$t,
                                                    _vm.mixin
                                                  ).message
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.getSaleStatus(
                                                    item,
                                                    _vm.$t,
                                                    _vm.mixin
                                                  ).message
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                  ]
                                ],
                                2
                              )
                            ])
                          })
                        ],
                        2
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11a9db4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11a9db4e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/sales/so/All.vue
// module id = null
// module chunks = 